import { ElementType, IElement } from '../../../../models/Element';
import { ElementHeaderType } from '../../../utils';

export type HomeShowcaseBoxHighlightLeft = IElement & {
  heading: string;
  heading_type?: ElementHeaderType;
  description: string;
  button_title: string;
  button_url: string;
  button_url_is_external: boolean;
  image_preview: string;
  image_preview_alt: string;
};

export const defaultHomeShowcaseBoxHighlightLeft: HomeShowcaseBoxHighlightLeft =
  {
    id: 0,
    name: ElementType.HOME_SHOWCASE_BOX_HIGHLIGHT_LEFT,
    heading: 'VoIP telefonie zonder gedoe',
    description:
      'Verbonden is hard op weg om één van de grootste telecomproviders te worden als het gaat om VoIP telefonie. Onze visie is om klanten telefonie te geven zonder gedoe.',
    button_title: 'Vertel meer!',
    button_url: '',
    button_url_is_external: false,
    image_preview: '',
    image_preview_alt: '',
  };
